import React, { createContext, useState } from "react";

import { ApiUtilisateurCourant } from 'types/apiReturns';

// https://react.dev/reference/react/useContext 


type ContainerProps = {
    children: React.ReactNode;
};

type UtilisateurCourantContextType = {
    utilisateur: ApiUtilisateurCourant | null;
    setUtilisateur: React.Dispatch<React.SetStateAction<ApiUtilisateurCourant | null>>
};


const utilisateurCourantContextState = {
    utilisateur: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setUtilisateur: () => { }
}

const UtilisateurCourantContext = createContext<UtilisateurCourantContextType>(utilisateurCourantContextState);

function UtilisateurCourantProvider(props: ContainerProps) {

    const [utilisateur, setUtilisateur] = useState<ApiUtilisateurCourant | null>(null);

    return (
        <UtilisateurCourantContext.Provider value={{utilisateur, setUtilisateur}}>        
            {props.children}
        </UtilisateurCourantContext.Provider>
    );
}

export { UtilisateurCourantContext, UtilisateurCourantProvider };
